import React, { useEffect, useState } from 'react';
import { toInteger } from 'lodash';

import numeral from 'numeral';

import moment from 'moment';

import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { AiFillApi } from "react-icons/ai";
import Page from 'src/components/Page';
import api from '../../services/api';

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';

import Results from './Results';
import Toolbar from './Toolbar';
import Location from './Location';
import Create from './Create';

import Activity from '../equipments/Activity';
import Usage from '../equipments/Usage';



const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  name: null,
  address: null,
  city: null,
  state: null,
  neighborhood: null,
  zipcode: null,
  phone: null,
  working: null,
  lon: 0.0,
  lat: 0.0,
  plan: null,
  position: '(0,0)'
}

const defaultDependencies = {
  loaded: false,
  locations: [],
  panels: []
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultUsageItem = {
  loaded: false,
  message: { inputs: [] },
  event: {},
  panel: { instruments: [] },
  alarm: {},
  device: {},
  schedules: [],
  commands: {}
};

const defaultGraphicData = {
  loaded: false,
  labels: [],
  datasets: []
};

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Nome', field: 'item.name', size: -1, sortable: 'name', exportable: 0, wrap: 0 },
  { name: 'Descrição', field: 'item.plan', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Endereço', field: 'item.address', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Bairro', field: 'item.neighborhood', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Cidade', field: 'item.city', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Estado', field: 'item.state', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'CEP', field: 'item.zipcode', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Coordenadas', field: '{item.lat + `, ` + item.lon}', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Posição Interna', field: 'item.position', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Criação', field: 'formatDatetime(item.createdAt)', size: -1, sortable: 'createdAt', exportable: 0, wrap: 0 }
];

const defaultEmptyMessage = "Nenhum Ponto de Instalação Foi Encontrado.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_DISABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_DISABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Ponto de Instalação pela Descrição', refine: 1, label: 'Descrição do Ponto de Instalação', history: 0 },
  { id: 2, name: 'Ponto de Instalação pela Descrição e Data de Criação', refine: 2, label: 'Descrição do Ponto de Instalação', history: 1 }
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  visao: defaultVisions[0]
}

const Locations = () => {

  const classes = useStyles();

  const [companyId, setCompanyId] = useState(localStorage.getItem('companyid'));

  const [graphicData, setGraphicData] = useState(defaultGraphicData);
  const [startDateTime, setStartDateTime] = useState(new Date());
  const [endDateTime, setEndDateTime] = useState(new Date());
  const [field, setField] = useState({});

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);

  const [state, setState] = useState(defaultState);
  const [usageItem, setUsageItem] = useState(defaultUsageItem);
  const [openUsageDialog, setOpenUsageDialog] = useState(false);
  const [openActivityDialog, setOpenActivityDialog] = useState(false);
  const [equipment, setEquipment] = useState({});
  const [checked, setChecked] = useState([]);

  const openExportDialog = async (format) => {
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const openEdition = async (item) => {
    setItem(item);
    setOpenEditionDialog(true);
  }

  const openCreation = (item) => {
    setItem(item);
    setOpenEditionDialog(true);
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: 'Ponto de Instalação',
      message: 'Deseja excluir o ponto de instalação selecionado?',
      warn: 'Esta ação irá interferir na localização dos equipamentos.',
      details: ['Não será possível recuperar o Ponto de Instalação excluido. Todos os processos relacionado a eventos apresentarão falha.']
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = (item) => {
    setItem(item);
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateTreatmentValues = (values) => {
    setItem(values);
    refreshItems();
  }

  const updateValues = (values) => {
    api.put('/locations/' + values._id, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao atualizar localização.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const createValues = (values) => {
    values.company = companyId;
    api.post('/locations', values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao criar localização.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const updateDependencies = async (values) => {

  };

  const deleteValues = (values) => {
    api.delete('/locations/' + values._id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao remover localização.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
    api.post('/locations/history', { filtro: value, company: companyId }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / value.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : value.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de equipamentos.', detail: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (startDateTime, endDateTime, vision, keyword, page, rows) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision
    };
    setVision(vision);
    setFilter(value);
    api.post('/locations/history', { filtro: value, company: companyId }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / value.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : value.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de equipamentos.', detail: error.message });
      setOpenAlert(true);
    })
  }

  const refreshItems = () => {
    api.post('/locations/history', { filtro: filter, company: companyId }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / filter.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : filter.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de equipamentos.', detail: error.message });
      setOpenAlert(true);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }

    const newEvent = (event) => {
      if (openUsageDialog || openActivityDialog) {
        new Promise(updateUsageItem).then((value) => {
          setUsageItem(value);
          if (openActivityDialog) {
            changeGraphic(field, startDateTime, endDateTime);
          }
        })
      }
    }

  }, []);

  const sendCommands = (commands, index, value) => {
    var vlr = 1;
    if (value === vlr) vlr = 0;
    commands.values[index] = vlr;
    api.put('/commands/' + commands._id, commands).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  }

  const changeGraphic = (field, sdt, edt) => {
    setField(field);
    setStartDateTime(sdt);
    setEndDateTime(edt);
    api.post('/events/activity', {
      filter: {
        device: localStorage.getItem('deviceid'),
        message: usageItem.message.code,
        sample: 200,
        startDateTime: sdt,
        endDateTime: edt
      }
    }, {
    }).then((response) => {
      if (!response.data.error) {
        var events = response.data;
        var data = {
          loaded: true,
          labels: [],
          datasets: []
        }

        if (field) {
          data.datasets.push(
            {
              label: 'Valor de ' + field.name + ' em ' + field.unit,
              fill: false,
              lineTension: 0.1,
              backgroundColor: 'rgba(75,152,255,0.5)',
              borderColor: 'rgba(75,152,255,0.5)',
              borderWidth: 1,
              data: []
            });

          field.tests.map((tst, tsti) => {
            data.datasets.push(
              {
                label: tst.description,
                fill: false,
                lineTension: 0.0,
                backgroundColor: (tst.rule && tst.rule.event && tst.rule.event.type && tst.rule.event.type == 'fail') ? 'rgba(255,0,0,0.5)' : 'rgba(255,255,0,0.5)',
                borderColor: (tst.rule && tst.rule.event && tst.rule.event.type && tst.rule.event.type == 'fail') ? 'rgba(255,0,0,0.5)' : 'rgba(255,255,0,0.5)',
                borderWidth: 1,
                pointRadius: 0,
                pointHitRadius: 0,
                data: []
              });
          });

          events.map((evt, evti) => {
            data.labels.push(moment(evt.createdAt).format('DD/MM HH:mm:ss'));
            var value = numeral(evt.data[field.order]).format(field.format);
            data.datasets[0].data.push(value);
            field.tests.map((tst, tsti) => {
              if (tst.rule && tst.rule.conditions && tst.rule.conditions.all && tst.rule.conditions.all.length > 0) {
                var level = tst.rule.conditions.all[tst.rule.conditions.all.length - 1].value
                data.datasets[tsti + 1].data.push(level);
              }
            });
          });
        }
        setGraphicData(data);
      }
    })
  }

  const openActivity = (item) => {
    setOpenActivityDialog(true);
  }

  const closeActivity = () => {
    setOpenActivityDialog(false);
  }

  const openUsage = (item) => {
    localStorage.setItem('deviceid', item.device);
    new Promise(updateUsageItem).then((value) => {
      setEquipment(item)
      setUsageItem(value)
      setOpenUsageDialog(true);
    }).catch((error) => {
      setMessage(error);
      setOpenAlert(true);
    })
  }

  const closeUsage = () => {
    setOpenUsageDialog(false);
  }

  const updateUsageItem = (resolve, reject) => {
    var deviceId = localStorage.getItem('deviceid');
    api.post('/events/device', { company: companyId, device: deviceId }, {
    }).then((response) => {
      var usageItem = defaultUsageItem;
      if (!response.data.error) {
        usageItem = {
          loaded: true,
          device: response.data.device,
          activation: response.data.activation,
          message: response.data.message,
          event: response.data.event,
          panel: response.data.panel,
          alarm: response.data.alarm,
          schedules: response.data.schedules,
          commands: response.data.commands
        };
        resolve(usageItem)
      } else {
        reject(response.data)
      }
    })
  }

  const handleToggle = (value, set) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex == -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  return (
    <Page
      className={classes.root}
      title="Pontos de Instalação"
    >
      <Container maxWidth={false}>

        <Toolbar
          icon={AiFillApi}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
        />

        <Activity open={openActivityDialog}
          equipment={item}
          usageItem={usageItem}
          closeActivity={closeActivity}
          changeGraphic={changeGraphic}
          graphicData={graphicData}
          field={field}
        />

        <Usage
          open={openUsageDialog}
          usageItem={usageItem}
          closeUsage={closeUsage}
          openAcitivity={openActivity}
          sendCommands={sendCommands} />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Confirmations item={item}
          message={message}
          open={openTreatmentDialog}
          close={closeTreatment}
          confirmation={updateTreatmentValues} />

        <Location item={item}
          open={openEditionDialog}
          closeEdition={closeEdition}
          updateValues={updateValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
          handleToggle={handleToggle}
          checked={checked}
        />

        <Create item={item}
          open={openCreationDialog}
          closeCreation={closeCreation}
          createValues={createValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
          handleToggle={handleToggle}
          checked={checked}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultSet={state}
                resultModes={resultModes}
                icon={AiFillApi}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
                changeSort={changeSort}
                openUsage={openUsage}
              />
            </CardContent>
          </Card>
        </Box>

      </Container>
    </Page>
  );
};

export default Locations;